const cardItems = [
  {
    id: 1,
    title: '少年Jump新连载速递',
    desc: '本季Jump系新作大盘点，哪些作品有爆款潜质？编辑逐一解读新连载的看点和作者背景。',
    tag: '新番速报',
    image: 'https://readdy.ai/api/search-image?query=Dynamic%20Japanese%20manga%20style%20illustration%20with%20action%20composition%2C%20warm%20coral%20and%20amber%20color%20palette%2C%20energetic%20shonen%20vibe%2C%20clean%20editorial%20layout%2C%20soft%20lighting%2C%20artistic%20rendering%2C%20no%20text&width=600&height=400&seq=cards-01&orientation=landscape',
  },
  {
    id: 2,
    title: '异世界日漫还能怎么创新',
    desc: '当异世界成为标配设定，哪些作品真正突破了套路？我们梳理了近年最具创意的异世界日漫。',
    tag: '深度分析',
    image: 'https://readdy.ai/api/search-image?query=Fantasy%20anime%20illustration%20with%20magical%20atmosphere%2C%20soft%20glowing%20particles%2C%20warm%20golden%20and%20amber%20tones%2C%20Japanese%20manga%20art%20style%2C%20dreamy%20composition%2C%20editorial%20quality%2C%20no%20text&width=600&height=400&seq=cards-02&orientation=landscape',
  },
  {
    id: 3,
    title: '少女漫画中的成长叙事',
    desc: '从《NANA》到《蜂蜜与四叶草》，少女漫画如何用细腻笔触描绘青春的迷茫与蜕变？',
    tag: '经典回顾',
    image: 'https://readdy.ai/api/search-image?query=Soft%20romantic%20anime%20illustration%20with%20cherry%20blossom%20petals%2C%20warm%20pink%20and%20coral%20tones%2C%20gentle%20lighting%2C%20shojo%20manga%20aesthetic%2C%20delicate%20composition%2C%20elegant%20Japanese%20art%20style%2C%20no%20text&width=600&height=400&seq=cards-03&orientation=landscape',
  },
  {
    id: 4,
    title: '悬疑日漫推荐：烧脑佳作合集',
    desc: '喜欢推理与反转？这份悬疑日漫清单收录了从社会派到本格推理的各类烧脑神作。',
    tag: '编辑精选',
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20anime%20illustration%20with%20dark%20atmospheric%20shadows%2C%20warm%20amber%20accents%2C%20thriller%20mood%2C%20Japanese%20manga%20composition%2C%20noir%20vibe%20with%20soft%20lighting%2C%20editorial%20style%2C%20no%20text&width=600&height=400&seq=cards-04&orientation=landscape',
  },
  {
    id: 5,
    title: '体育日漫的热血精神传承',
    desc: '从《灌篮高手》到《蓝色监狱》，体育漫画如何用竞技诠释青春、团队与永不言弃？',
    tag: '专题策划',
    image: 'https://readdy.ai/api/search-image?query=Dynamic%20sports%20anime%20illustration%20with%20motion%20lines%2C%20energetic%20composition%2C%20warm%20amber%20and%20coral%20sunset%20lighting%2C%20Japanese%20manga%20style%2C%20inspiring%20atmosphere%2C%20no%20text&width=600&height=400&seq=cards-05&orientation=landscape',
  },
  {
    id: 6,
    title: '2026上半年日漫阅读报告',
    desc: '樱花动漫之家发布半年度数据报告，哪些作品霸榜？哪些冷门逆袭？一图看尽半年趋势。',
    tag: '数据报告',
    image: 'https://readdy.ai/api/search-image?query=Clean%20modern%20infographic%20style%20illustration%20with%20Japanese%20manga%20aesthetic%2C%20warm%20minimal%20design%2C%20data%20visualization%20feel%2C%20soft%20coral%20and%20amber%20palette%2C%20editorial%20layout%2C%20no%20text&width=600&height=400&seq=cards-06&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3">
            编辑推荐
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            编辑精选
          </h2>
          <p className="text-foreground-500 text-sm mt-2">深度选题与专业日漫解读</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cardItems.map((item) => (
            <article key={item.id} className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/70 cursor-pointer hover:border-background-300 transition-all">
              <div className="aspect-[3/2] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <span className="text-[10px] px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 font-medium whitespace-nowrap mb-2 inline-block">
                  {item.tag}
                </span>
                <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}